var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141.187,
    height: 21.236,
    viewBox: "0 0 141.187 21.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 141.187,
    height: 21.236,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M22.749,0,24.91,5.986a31.534,31.534,0,0,1-12.454,2.55A31.506,31.506,0,0,1,0,5.984L2.161,0a25.143,25.143,0,0,0,10.3,2.188A25.126,25.126,0,0,0,22.749,0M12.456,14.888A25.143,25.143,0,0,1,2.161,12.7L0,18.684a31.506,31.506,0,0,0,12.456,2.552A31.55,31.55,0,0,0,24.91,18.687L22.749,12.7a25.126,25.126,0,0,1-10.293,2.188m107.351-4.666a10.846,10.846,0,0,1-11.285,11.014h-7.068V0h7.523c7.16,0,10.83,5,10.83,10.222m-4.9,0c0-3.034-1.8-5.72-5.832-5.72H106.3V16.734h2.173c4.35,0,6.433-3.225,6.433-6.512M77.342,21.236l-4.7-8.9A6.1,6.1,0,0,0,75.98,6.678C75.98,3.352,73.65,0,68.02,0H59.537V21.236h4.844V13.328h3.478l4.063,7.908ZM64.381,9.191V4.5H67c2.488,0,3.876.472,3.876,2.3,0,2.043-1.6,2.383-3.876,2.383ZM49.847,0H43.876L36.309,21.236h4.975l1.425-4.207h8.305l1.425,4.207h4.975ZM44.175,12.7l2.687-7.934L49.548,12.7ZM91.611,0H85.64L78.073,21.236h4.975l1.425-4.207h8.305L94.2,21.236h4.975ZM85.939,12.7l2.686-7.934L91.312,12.7ZM133.62,0h-5.971l-7.567,21.236h4.975l1.425-4.207h8.305l1.425,4.207h4.975Zm-5.672,12.7,2.687-7.934,2.686,7.934Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/p1.fe19f546617b532822e2d1f9a2f5424e.svg";
export { ForwardRef as ReactComponent };